module.exports = __webpack_public_path__ + "img/ic_air_pressure.e9a01892.png";